export enum NotificationMessages {
    POA_UPDATED = 'NOTIFICATION_MESSAGES.POA_UPDATED',
    POA_UPDATING_ERROR = 'NOTIFICATION_MESSAGES.POA_UPDATING_ERROR',
    SHIPPING_CLASSES_UPDATED = 'NOTIFICATION_MESSAGES.SHIPPING_CLASSES_UPDATED',
    SHIPPING_CLASSES_UPDATING_ERROR = 'NOTIFICATION_MESSAGES.SHIPPING_CLASSES_UPDATING_ERROR',
    SHIPPING_CLASSES_HAS_STOCK = 'NOTIFICATION_MESSAGES.SHIPPING_CLASSES_HAS_STOCK',
    STANDARD_FEATURES_UPDATED = 'NOTIFICATION_MESSAGES.STANDARD_FEATURES_UPDATED',
    STANDARD_FEATURES_FAILED = 'NOTIFICATION_MESSAGES.STANDARD_FEATURES_FAILED'
}
